import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
import { DashboardConstants } from '../../actions/constant';
const {
  GET_GAME_BY_INTERVENTION_REQUEST,
  GET_GAME_BY_INTERVENTION_SUCCESS,
  GET_GAME_BY_INTERVENTION_FAILURE,
  GET_GAME_BY_INTERVENTION_LOADER,
  GET_GAME_BY_INTERVENTION_RESET,
} = DashboardConstants;

function* dashboardGameByInterventionGroup(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_GAME_BY_INTERVENTION_LOADER });
    const response = yield call(dashboardServices.getGameByIntervention, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_GAME_BY_INTERVENTION_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_GAME_BY_INTERVENTION_FAILURE, payload: error });
  }
}

function* dashboardGameByInterventionGroupSaga() {
  yield takeEvery(GET_GAME_BY_INTERVENTION_REQUEST, dashboardGameByInterventionGroup);
}

export default dashboardGameByInterventionGroupSaga;
